<template>
  <a :href="href" class="sidebar-menu__sub-link" target="_blank"><slot></slot></a>
</template>

<script>
  export default {
    props: {
      href: {
        type: String,
        required: true
      }
    }
  };
</script>
